module.exports = __webpack_public_path__ + "static/img/8.cc813e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/8.png
// module id = 1t7r
// module chunks = 0